/**
 * **커플링 판정 — 하나**(D-114). 실행(또는 짓고 있는 작업)의 참가자가 둘 이상이면 커플링이고, 하나면 단독이다. 커플링이면 공유
 * preCICE 설정·결선이 필요하고, 시각 구간은 커플링 시각(0 부터 preCICE 최대 시각)이며, 실행 기록의 실행 방식은 `cosim` 이다.
 * 프로젝트 실행 화면·프로젝트 모델 탭·퀵 실행(결선 필수 검사·공유 설정 판정·단일 화면 판정)·실행 기록(헤더·읽기)·시각 구간이 이것 하나를 읽는다.
 */
export const COUPLING_MIN_PARTICIPANTS = 2;

export const isCoupling = (participants: { readonly length: number }): boolean => participants.length >= COUPLING_MIN_PARTICIPANTS;

/** 단독이면 그 참가자 하나, 커플링이거나 참가자가 없으면 없음 — 단독 실행의 대상·이력의 단독 귀속·세션의 활성 모델이 읽는다 */
export function soleParticipant<T>(participants: readonly T[]): T | undefined {
  return participants.length > 0 && !isCoupling(participants) ? participants[0] : undefined;
}
